export default __webpack_public_path__ + "static/media/YAS0930.34I-42407_-25402_0.2733bc7e.jpg";